import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "integrations",
  "use": "integrations-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.414\" id=\"integrations\"><path d=\"M10.021 3.354A3.001 3.001 0 1116 3a3.001 3.001 0 01-5.082 2.159l-4.941 2.47a3.041 3.041 0 010 .742l4.94 2.471A3.001 3.001 0 1113 16a3.001 3.001 0 01-2.983-3.319c-1.658-.818-3.301-1.667-4.947-2.51A3.001 3.001 0 113 5c.79 0 1.509.306 2.046.806 1.648-.836 3.313-1.641 4.975-2.452z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/integrations.svg
// module id = 43S0
// module chunks = 39 44